module.exports = __webpack_public_path__ + "img/Hypoxia-CRC_10X_WTA.b711f406.png";